import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type DomainZoneInvalidTypeErrorOptions = {
  zone: ObjectId;
};

export class DomainZoneInvalidTypeError extends FleekError<DomainZoneInvalidTypeErrorOptions> {
  public name = 'DomainZoneInvalidTypeError';

  toString = () => 'Domain zone has different purpose of use.';
}
